import React from "react";
import { connect } from "react-redux";
import { Modal, message, Form, Button, Table,Input } from 'antd';
import DynamicTable from "../../components/frame/DynamicTable";
import DynamicFilter from "../../components/frame/DynamicFilter";
import DynamicButton from "../../components/frame/DynamicButton";
import ReactAbstract from "../../components/abstract/React.abstract";
import { fetchDepartmentsList } from '../../actions/department-structure-actions';
import bestEmployeeStatisticService from '../../services/WorkReport/best-employee-statistic-service';

export default class BestStar extends ReactAbstract {

    initReload = false
    dataMode = 0
    deleteRowSelection = false
    moduleName = "report"
    childModuleName = "dailyReportrexceptionStatistics"
    state = {
        currentModalStatus: false,
        currentIndex: null,
        currentData: [],
        currentDataStatus: "loaded",
        currentDataFilters: {},
        filters: {
            start_time: null,
            end_time: null
        },
        data: [],
        dataStatus: "loaded",
    }
    actions = {
        selectAction: bestEmployeeStatisticService.getBestStarList,
        exportAction: bestEmployeeStatisticService.exportBestStarList,
    }

    headerColumn = [{
        title: "导出",
        access: "export_value",
        icon: "cloud-download-o",
        click: this.publicExport
    }
    ]

    filterColumn = [
        {
            type: "department"
        }, {
            type: "date",
            label: "结束时间",
            key: "search_end_time",
        }, {
            type: "date",
            label: "开始时间",
            key: "search_start_time",
        }
    ]


    tableColumn = [{
        title: '工号',
        dataIndex: 'job_number',
        key: 'job_number',
    }, {
        title: '员工姓名',
        dataIndex: 'employee_name',
        key: 'employee_name',
    }, {
        title: '英文名',
        dataIndex: 'english_name',
        key: 'english_name',
    }, {
        title: '部门',
        dataIndex: 'department_name',
        key: 'department_name',
    }, {
        title: '职位',
        dataIndex: 'position_name',
        key: 'position_name',
    }, {
        title: '票数',
        dataIndex: 'vote',
        key: 'vote',
    }, {
        title: '操作',
        dataIndex: 'actions',
        key: 'actions',
        className: 'table-global-head-small',
        render: (text, record, index) => (
            <DynamicButton column={this.buttonColumn(text, record, index)}
                module={this.childModuleName}
                access={this.props.access} />
        )
    }];


    detailTableColumn = [{
        title: '日期',
        dataIndex: 'weekStr',
        key: 'weekStr',
        width: 400
    }, {
        title: '推荐人',
        dataIndex: 'referer_english',
        key: 'referer_english',
        width: 200
    }, {
        title: '原因',
        dataIndex: 'reason',
        key: 'reason',
        width: 600,
        render: (text, record) => (
            <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                {text}
            </div>
        ),
    }];

    buttonColumn = (text, record, index) => [{
        size: "small",
        type: "default",
        icon: "edit",
        title: "查看",
        access: "u_value",
        click: this.updateData.bind(this, record, index),
    }]

    updateData = (record, index) => this.setState({
        currentModalStatus: true,
        currentDataStatus: "loading",
        currentIndex: index
    }, () => {

        let gets = {
            start_date: this.state.filters.search_start_time,
            end_date: this.state.filters.search_end_time,
            job_number: record.job_number
        }
        this.setState({ currentDataFilters: gets })
        this.getBestEmployeeReason(gets)
    })
    getBestEmployeeReason = (gets) => {
        bestEmployeeStatisticService
            .getBestStarReason(gets, res => {
                console.log(res)
                console.log(res.data.Success)
                if (res.data.Success || res.data.Success === undefined) {
                    this.setState({
                        currentDataStatus: "loaded",
                        currentData: res.data.Object
                    })
                }
                else {
                    message.error(res.data.Message)
                    this.setState({
                        currentDataStatus: "loaded",
                    })
                }
            })
    }



    customComponentWillMount() {
        this.props.fetchDepartmentsList()
    }

    //#region publicChange(更改条件后不会触发查询)
    publicChange = (filters) => this.setState({
        filters: {
            ...this.state.filters,
            ...filters,
        }
    })
    privateSelect = (filters) => this.setState({
        filters: {
            ...this.state.filters,
            ...filters,
        }

    }, () => {
        this.publicSelect()
    })
    //#endregion

    setNameFilter = value => {
        this.setState({
            filters: {
                ...this.state.filters,
                employee_info: value,
                page: 1
            }
        }, this.publicSelect)
    }
    render() {
        return (
            <div className="app-module-item">
                <div className="app-module-header">
                    <DynamicButton column={this.headerColumn}
                        module={this.childModuleName}
                        access={this.props.access} />

                    {/* <div className="colAction" style={{ float: "right", margin: "0px 10px 10px 0px" }}>
                        <Button type="primary" onClick={this.publicSelect}>
                            <span>查询</span>
                        </Button>
                    </div> */}
                    <div className="colAction"
                        style={{ float: "right", margin: "0px 10px 10px 0px" }}>
                        <Input.Search
                            placeholder="请输入工号或姓名"
                            onSearch={this.setNameFilter}
                            style={{ width: 200 }}
                            enterButton />
                    </div>
                    <DynamicFilter column={this.filterColumn}
                        departmentsList={this.props.departmentStructure.departmentsList}
                        value={this.dataSource().filters}
                        setFilter={this.publicChange} />
                </div>
                <Modal width="900px"
                    maskClo sable={false}
                    visible={this.state.currentModalStatus}
                    title="查看"
                    destroyOnClose={true}
                    onCancel={this.toggleCurrentModal}
                    footer={<Button type="back" onClick={this.toggleCurrentModal}>关闭</Button>}>
                    <Table columns={this.detailTableColumn}
                        rowKey={(record, index) => index}
                        dataSource={this.dataSource().currentData}
                        pagination={false}
                    />
                </Modal>
                <div>
                    <DynamicTable column={this.tableColumn}
                        dataStatus={this.dataSource().dataStatus}
                        dataSource={this.dataSource().data.Data}
                        pagination={{
                            total: this.dataSource().data.Total,
                            pageSize: this.dataSource().data.PageSize,
                            current: this.dataSource().filters.page
                        }}
                        setPageFilter={this.publicChangeForSelect} />
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        departmentStructure: state.departmentStructure,
    }
}
const mapDispatchToProps = {
    fetchDepartmentsList,
}
BestStar = connect(mapStateToProps, mapDispatchToProps)(Form.create()(BestStar));



// WEBPACK FOOTER //
// ./src/routes/WorkReport/BestStar.js